import { isAllowed } from '@ion/api/Apollo/allower';
import permissions from '@ion/api/Apollo/permissions';

export default function isAllowedToDeleteUser() {
  return isAllowed(permissions.deleteUsers);
}
